import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import ClientTable from '../../../../../components/table/Client.table'
import ConfirmModal from '../../../../../components/Modal/Confirm.modal';
import { faXmarkCircle, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router';
import AdminService from '../../../../../services/admin.service';
import toast from 'react-hot-toast';

export default function ExamClients() {
    const params = useParams();
    const [showCreateClient, setShowCreateClient] = useState<boolean>(false);
    const [clients, setClients] = useState<any>();
    const [newClientEmail, setNewClientEmail] = useState<string>("");


    const getAllClients = async () => {
        await AdminService.getAllClients(params.examId).then((res) => {
            if (res.status === 200) {
                console.log(res.data);
                setClients(res.data.data.client);
            }
        });
    };

    const handleCreateClient = async () => {
        // if(!newClientEmail){
        //     toast.error("Please enter client email");
        //     return;
        // }
        await AdminService.createClient(params.examId, { email: newClientEmail })
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Client created successfully");
                    getAllClients();
                    setShowCreateClient(false);

                    setNewClientEmail("");
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data || "Unable to create client");
            });
    };


    useEffect(() => {
        getAllClients();
    }, []);

    return (
        <>
            <div className="mt-3">
                <div className="d-flex justify-content-between align-items-center">
                    <p
                        style={{ fontSize: "18px", fontWeight: "bold" }}
                        className="mt-2"
                    >
                        Clients
                    </p>
                    <Button
                        variant="outline-primary"
                        className="fw-bold"
                        size="sm"
                        onClick={() => setShowCreateClient(true)}
                    >
                        Create Client
                    </Button>
                </div>
                <div>
                    <ClientTable
                        clients={clients}
                        examId={params.examId}
                        reload={getAllClients}
                    />
                </div>
            </div>

            <ConfirmModal
                titleText={"Create Client Modal"}
                bodyText={
                    <>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Client Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter client email"
                                value={newClientEmail}
                                onChange={(e: any) => setNewClientEmail(e.target.value)}
                            />
                        </Form.Group>
                    </>
                }
                show={showCreateClient}
                onHide={() => setShowCreateClient(false)}
                button={[
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faXmarkCircle} /> Cancel
                            </>
                        ),
                        action: () => setShowCreateClient(false),
                        variant: "secondary",
                    },
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faCheck} /> Create
                            </>
                        ),
                        action: handleCreateClient,
                        variant: "success",
                    },
                ]}
            />
        </>
    )
}